<template>
    <div class="dashboard-root">

        <!-- ── Toolbar / DatePicker ─────────────────────────────────── -->
        <div class="dash-toolbar">
            <div class="date-picker-wrap dp-input-wrapper">
                <span class="dp-cal-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                        <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
                    </svg>
                </span>
                <DatePicker
                    v-model="datePiker"
                    dateFormat="dd/mm/yy"
                    placeholder="Selecionar data"
                    @value-change="onDateChange"
                />
            </div>
        </div>

        <!-- ── KPI Row ──────────────────────────────────────────────── -->
        <div class="kpi-row">
            <KpiCard :value="infosGerais.totalClientes"        label="Clientes"         />
            <KpiCard :value="infosGerais.totalUsuarios"        label="Usuários"          />
            <KpiCard :value="infosGerais.totalContratosAtivos" label="Contratos Ativos"  />
            <KpiCard :value="infosGerais.totalEmContratacao"   label="Em Contratação"    />
            <KpiCard :value="infosGerais.totalPendencias"      label="Pendências" variant="danger" />
            <div
                v-if="permissoes.CANCELAMENTO_VISUALIZAR"
                class="kpi-card-wrap"
                role="button"
                tabindex="0"
                aria-label="Ver cancelamentos em aberto"
                @click="irCancelamentos"
                @keydown.enter="irCancelamentos"
            >
                <KpiCard
                    :value="infosGerais.totalCancelamentosAbertos"
                    label="Cancel. abertos"
                    variant="warning"
                />
            </div>
        </div>

        <!-- ── Top Grid: Gráfico horizontal + Tabela ───────────────── -->
        <div class="top-grid">
            <!-- Gráfico Horizontal Etapas -->
            <div class="dash-card">
                <h4 class="card-title">ETAPAS / SEMANA ATUAL</h4>
                <HorizontalBarEtapas :rawData="etapasDias" :colorMap="etapaColorMap" />
                <div v-if="isLoading.etapasDias" class="chart-loader">
                    <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="6" />
                    <span>CARREGANDO GRÁFICO...</span>
                </div>
            </div>

            <!-- Tabela Dark Etapas -->
            <div class="dash-card">
                <h4 class="card-title">ETAPAS / SEMANA ATUAL</h4>
                <DarkDataTableEtapas
                    :labels="etapasDias.labels || []"
                    :datasets="etapasDias.datasets || []"
                    :colorMap="etapaColorMap"
                />
                <div v-if="isLoading.etapasDias" class="chart-loader">
                    <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="6" />
                    <span>CARREGANDO GRÁFICO...</span>
                </div>
            </div>
        </div>

        <!-- ── Middle Grid: 4 charts ───────────────────────────────── -->
        <div class="mid-grid">
            <div class="dash-card">
                <h4 class="card-title">QTD / ETAPAS</h4>
                <VerticalBarQtdEtapas :rawData="qtdEtapas" :colorMap="etapaColorMap" />
                <div v-if="isLoading.qtdEtapas" class="chart-loader">
                    <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="6" />
                    <span>CARREGANDO GRÁFICO...</span>
                </div>
            </div>

            <div class="dash-card">
                <h4 class="card-title">CONTRATOS CONCLUÍDOS / MÊS</h4>
                <RadialConcluidosMes :rawData="contratosMes" />
                <div v-if="isLoading.contratosMes" class="chart-loader">
                    <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="6" />
                    <span>CARREGANDO GRÁFICO...</span>
                </div>
            </div>

            <div class="dash-card">
                <h4 class="card-title">ATUAÇÃO / ESTADO</h4>
                <PieAtuacaoEstado :rawData="atuacaoEstado" />
                <div v-if="isLoading.atuacaoEstado" class="chart-loader">
                    <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="6" />
                    <span>CARREGANDO GRÁFICO...</span>
                </div>
            </div>

            <div class="dash-card">
                <h4 class="card-title">CONTRATOS / MENORES - MÊS ATUAL</h4>
                <SimpleVerticalBarUsuarios :rawData="usuariosContratosMesMenores" />
                <div v-if="isLoading.usuariosMenores" class="chart-loader">
                    <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="6" />
                    <span>CARREGANDO GRÁFICO...</span>
                </div>
            </div>
        </div>

        <!-- ── Bottom Grid: 2 wide charts ──────────────────────────── -->
        <div class="bot-grid">
            <div class="dash-card">
                <h4 class="card-title">CONTRATOS / MÊS ÚLTIMO ANO</h4>
                <ActiveBarContratosMes :rawData="etapasMes" />
                <div v-if="isLoading.etapasMes" class="chart-loader">
                    <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="6" />
                    <span>CARREGANDO GRÁFICO...</span>
                </div>
            </div>

            <div class="dash-card">
                <h4 class="card-title">MAIORES CLIENTES</h4>
                <ActiveBarMaioresClientes :rawData="contratoMaioresClientes" />
                <div v-if="isLoading.maioresClientes" class="chart-loader">
                    <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="6" />
                    <span>CARREGANDO GRÁFICO...</span>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
// KPI & Table
import KpiCard               from './components/KpiCard.vue';
import DarkDataTableEtapas   from './components/DarkDataTableEtapas.vue';
// Charts
import HorizontalBarEtapas      from './components/HorizontalBarEtapas.vue';
import VerticalBarQtdEtapas     from './components/VerticalBarQtdEtapas.vue';
import RadialConcluidosMes      from './components/RadialConcluidosMes.vue';
import PieAtuacaoEstado         from './components/PieAtuacaoEstado.vue';
import SimpleVerticalBarUsuarios from './components/SimpleVerticalBarUsuarios.vue';
import ActiveBarContratosMes    from './components/ActiveBarContratosMes.vue';
import ActiveBarMaioresClientes  from './components/ActiveBarMaioresClientes.vue';
// PrimeVue
import DatePicker from 'primevue/datepicker';
import ProgressSpinner from 'primevue/progressspinner';
// Services
import Cliente   from '@/service/cliente.js';
import Usuario   from '@/service/usuario.js';
import Contrato  from '@/service/contrato.js';
import Pendencia from '@/service/pendencia.js';
import Cancelamento from '@/service/cancelamento.js';

export default {
    components: {
        KpiCard,
        DarkDataTableEtapas,
        HorizontalBarEtapas,
        VerticalBarQtdEtapas,
        RadialConcluidosMes,
        PieAtuacaoEstado,
        SimpleVerticalBarUsuarios,
        ActiveBarContratosMes,
        ActiveBarMaioresClientes,
        DatePicker,
        ProgressSpinner,
    },

    data() {
        return {
            datePiker: new Date(),
            isLoading: {
                totais: false,
                etapasDias: false,
                etapasMes: false,
                qtdEtapas: false,
                usuariosMaiores: false,
                usuariosMenores: false,
                contratosMes: false,
                atuacaoEstado: false,
                maioresClientes: false,
            },

            infosGerais: {
                totalClientes: 0,
                totalUsuarios: 0,
                totalContratosAtivos: 0,
                totalEmContratacao: 0,
                totalPendencias: 0,
                totalCancelamentosAbertos: 0,
            },

            permissoes: typeof permissoes !== 'undefined' ? permissoes : {},

            cancelamentoDashboard: null,

            // Color map compartilhado com todos os gráficos de etapas
            etapaColorMap: {
                'Lead':                '#3b82f6',
                'Cotação':             '#e11d48',
                'Aguardando Aprovação':'#d97706',
                'Provedor':            '#f59e0b',
                'Assinatura':          '#8b5cf6',
                'Agendamento':         '#0ea5e9',
                'Instalação':          '#a3a3a3',
                'Concluído':           '#22c55e',
                'Cancelado':           '#ef4444',
            },

            etapasDias:                  {},
            etapasMes:                   {},
            qtdEtapas:                   {},
            usuariosContratosMesMaiores: {},
            usuariosContratosMesMenores: {},
            contratosMes:                {},
            atuacaoEstado:               {},
            contratoMaioresClientes:     {},
        };
    },

    mounted() {
        this.onDateChange();
        // dados que não dependem de data
        this.loadEstados();
        this.loadMeses();
        this.loadClientes();
        this.loadCancelamentoDashboard();
        document.addEventListener('onPermissios', (event) => {
            this.permissoes = event.permissoes;
            this.loadCancelamentoDashboard();
        });
    },

    methods: {
        onDateChange() {
            this.loadTotais();
            this.loadEtapasSemanal();
            this.loadEtapasMensal();
            this.loadEtapasQuantidades();
            this.loadMaioresUsuarios();
            this.loadMenoresUsuarios();
        },

        /* ── Data loaders ─────────────────────────────────────────── */

        loadTotais() {
            Cliente.total()
                .then(r => { this.infosGerais.totalClientes = r.data.total; });
            Usuario.totalAtivo()
                .then(r => { this.infosGerais.totalUsuarios = r.data.total; });
            Contrato.totalConcluidoVigente()
                .then(r => { this.infosGerais.totalContratosAtivos = r.data.total; });
            Contrato.totalContratacao()
                .then(r => { this.infosGerais.totalEmContratacao = r.data.total; });
            Pendencia.totalPendente()
                .then(r => { this.infosGerais.totalPendencias = r.data.total; });
        },

        loadCancelamentoDashboard() {
            if (!this.permissoes.CANCELAMENTO_VISUALIZAR) {
                this.cancelamentoDashboard = null;
                this.infosGerais.totalCancelamentosAbertos = 0;
                return;
            }
            Cancelamento.fetchDashboard()
                .then((data) => {
                    this.cancelamentoDashboard = data;
                    this.infosGerais.totalCancelamentosAbertos = data.total_abertos ?? 0;
                })
                .catch(() => {});
        },

        irCancelamentos() {
            this.$router.push({ name: 'cancelamento.fila' });
        },

        loadEtapasSemanal() {
            this.isLoading.etapasDias = true;
            const date = this.datePiker;
            Contrato.etapasSemanal([`data=${date.toISOString().split('T')[0]}`].join('&'))
                .then(response => {
                    const data     = response.data.data;
                    const labels   = response.data.labels;
                    const datasets = [];
                    data.forEach(item => {
                        item.etapas.forEach((item2, idx2) => {
                            if (!datasets[idx2]) {
                                datasets[idx2] = { label: item2.etapa, data: [], tension: 0.4 };
                            }
                            datasets[idx2].data.push(item2.total);
                        });
                    });
                    this.etapasDias = { labels, datasets };
                })
                .catch(e => {
                    this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao carregar Etapas / Semana', life: 5000 });
                })
                .finally(() => {
                    this.isLoading.etapasDias = false;
                });
        },

        loadEtapasMensal() {
            this.isLoading.etapasMes = true;
            const date = this.datePiker;
            Contrato.etapasMensal([`data=${date.toISOString().split('T')[0]}`].join('&'))
                .then(response => {
                    const data     = response.data.data;
                    const labels   = response.data.labels;
                    const datasets = [
                        { label: 'Ativos',         data: [] },
                        { label: 'Cancelamentos',  data: [] },
                        { label: 'Crescimento',    data: [] },
                    ];
                    data.forEach(item => {
                        datasets[0].data.push(item.concuido);
                        datasets[1].data.push(item.cancelado);
                        datasets[2].data.push(item.concuido - item.cancelado);
                    });
                    this.etapasMes = { labels, datasets };
                })
                .catch(e => {
                    this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao carregar Etapas / Mês', life: 5000 });
                })
                .finally(() => {
                    this.isLoading.etapasMes = false;
                });
        },

        loadEtapasQuantidades() {
            this.isLoading.qtdEtapas = true;
            const date = this.datePiker;
            Contrato.etapasQuantidade([`data=${date.toISOString().split('T')[0]}`].join('&'))
                .then(response => {
                    const data     = response.data.data;
                    const labels   = [];
                    const datasets = [{ label: 'Status', data: [] }];
                    data.forEach((item, idx) => {
                        labels[idx] = item.etapa;
                        datasets[0].data.push(item.total);
                    });
                    this.qtdEtapas = { labels, datasets };
                })
                .catch(e => {
                    this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao carregar Quantidade por Etapas', life: 5000 });
                })
                .finally(() => {
                    this.isLoading.qtdEtapas = false;
                });
        },

        loadMaioresUsuarios() {
            this.isLoading.usuariosMaiores = true;
            const date = this.datePiker;
            Contrato.usuariosQuantidade([`data=${date.toISOString().split('T')[0]}`].join('&'))
                .then(response => {
                    const data     = response.data.data;
                    const labels   = [];
                    const datasets = [{ label: 'Contratos', data: [] }];
                    data.forEach((item, idx) => {
                        labels[idx] = item.usuario;
                        datasets[0].data.push(item.total);
                    });
                    this.usuariosContratosMesMaiores = { labels, datasets };
                })
                .catch(e => {
                    this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao carregar Maiores Usuários', life: 5000 });
                })
                .finally(() => {
                    this.isLoading.usuariosMaiores = false;
                });
        },

        loadMenoresUsuarios() {
            this.isLoading.usuariosMenores = true;
            const date = this.datePiker;
            Contrato.usuariosQuantidade([`data=${date.toISOString().split('T')[0]}`, 'desc=1'].join('&'))
                .then(response => {
                    const data     = response.data.data;
                    const labels   = [];
                    const datasets = [{ label: 'Contratos', data: [] }];
                    data.forEach((item, idx) => {
                        labels[idx] = item.usuario;
                        datasets[0].data.push(item.total);
                    });
                    this.usuariosContratosMesMenores = { labels, datasets };
                })
                .catch(e => {
                    this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao carregar Menores Usuários', life: 5000 });
                })
                .finally(() => {
                    this.isLoading.usuariosMenores = false;
                });
        },

        loadMeses() {
            this.isLoading.contratosMes = true;
            Contrato.mesesQuantidade()
                .then(response => {
                    const data     = response.data.data;
                    const labels   = [];
                    const datasets = [{ label: 'Contratos', data: [] }];
                    data.forEach((item, idx) => {
                        labels[idx] = item.mes;
                        datasets[0].data.push(item.total);
                    });
                    this.contratosMes = { labels, datasets };
                })
                .catch(e => {
                    this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao carregar Contratos por Mês', life: 5000 });
                })
                .finally(() => {
                    this.isLoading.contratosMes = false;
                });
        },

        loadEstados() {
            this.isLoading.atuacaoEstado = true;
            Contrato.estadosQuantidade()
                .then(response => {
                    const data     = response.data.data;
                    const labels   = [];
                    const datasets = [{ label: 'Contratos', data: [] }];
                    data.forEach((item, idx) => {
                        labels[idx] = `${item.estado} (${item.uf})`;
                        datasets[0].data.push(item.total);
                    });
                    this.atuacaoEstado = { labels, datasets };
                })
                .catch(e => {
                    this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao carregar Atuação por Estado', life: 5000 });
                })
                .finally(() => {
                    this.isLoading.atuacaoEstado = false;
                });
        },

        loadClientes() {
            this.isLoading.maioresClientes = true;
            Contrato.clientesQuantidade()
                .then(response => {
                    const data     = response.data.data;
                    const labels   = [];
                    const datasets = [{ label: 'Contratos', data: [] }];
                    data.forEach((item, idx) => {
                        labels[idx] = item.cliente;
                        datasets[0].data.push(item.total);
                    });
                    this.contratoMaioresClientes = { labels, datasets };
                })
                .catch(e => {
                    this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao carregar Maiores Clientes', life: 5000 });
                })
                .finally(() => {
                    this.isLoading.maioresClientes = false;
                });
        },
    }
};
</script>

<style scoped>
/* ── Root ────────────────────────────────────────────────────── */
.dashboard-root {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 0 2px 16px;
    min-height: 100%;
}

/* ── Toolbar ─────────────────────────────────────────────────── */
.dash-toolbar {
    display: flex;
    justify-content: flex-end;
    padding: 4px 0;
}

/* ── Date Picker wrap ───────────────────────────────────── */
.date-picker-wrap {
    position: relative;
    display: flex;
    align-items: center;
}
.dp-cal-icon {
    position: absolute;
    left: 11px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    z-index: 2;
    color: #6b7280;
    display: flex;
}
.dp-cal-icon svg {
    width: 15px;
    height: 15px;
}

/* Input nativo do DatePicker */
.dp-input-wrapper :deep(input) {
    background: #1a1a1a !important;
    color: #e6edf3 !important;
    border: 1px solid #2a2a2a !important;
    border-radius: 8px !important;
    padding: 7px 12px 7px 36px !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    width: 148px;
    cursor: pointer;
    transition: border-color 160ms ease !important;
    caret-color: #f97316;
}
.dp-input-wrapper :deep(input)::placeholder {
    color: #6b7280;
}
.dp-input-wrapper :deep(input):focus {
    outline: none !important;
    border-color: #f97316 !important;
    box-shadow: 0 0 0 2px rgba(249,115,22,.18) !important;
}

/* Botão de ícone embutido do PrimeVue (removemos o nativo) */
:deep(.dp-root .p-datepicker-trigger) {
    display: none !important;
}

/* Painel flutuante */
:deep(.dp-panel),
:deep(.p-datepicker-panel) {
    background: #1e1e1e !important;
    border: 1px solid #2a2a2a !important;
    border-radius: 12px !important;
    box-shadow: 0 16px 48px rgba(0,0,0,.6) !important;
    overflow: hidden;
    margin-top: 6px;
    padding: 0 !important;
}

/* Header do calendário (mês/ano + setas) */
:deep(.p-datepicker-header) {
    background: #242424 !important;
    border-bottom: 1px solid #2a2a2a !important;
    padding: 10px 14px !important;
    display: flex;
    align-items: center;
    gap: 6px;
}
:deep(.p-datepicker-prev-button),
:deep(.p-datepicker-next-button) {
    background: transparent !important;
    border: 1px solid #2a2a2a !important;
    border-radius: 6px !important;
    color: #9ca3af !important;
    width: 28px !important;
    height: 28px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 140ms ease, border-color 140ms ease !important;
}
:deep(.p-datepicker-prev-button:hover),
:deep(.p-datepicker-next-button:hover) {
    background: #2a2a2a !important;
    border-color: #f97316 !important;
    color: #f97316 !important;
}

/* Seletor de mês e ano */
:deep(.p-datepicker-select-month),
:deep(.p-datepicker-select-year) {
    background: transparent !important;
    border: none !important;
    color: #e6edf3 !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    cursor: pointer;
}
:deep(.p-datepicker-select-month:hover),
:deep(.p-datepicker-select-year:hover) {
    color: #f97316 !important;
}

/* Cabeçalho dos dias (S M T W T F S) */
:deep(.p-datepicker-weekday) {
    color: #6b7280 !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    padding: 6px 0 !important;
}

/* Células dos dias */
:deep(.p-datepicker-day) {
    border-radius: 6px !important;
    color: #d1d5db !important;
    transition: background 120ms ease !important;
    font-size: 13px !important;
}
:deep(.p-datepicker-day:hover) {
    background: #2a2a2a !important;
    color: #fff !important;
}
:deep(.p-datepicker-day-selected) {
    background: #f97316 !important;
    color: #fff !important;
    font-weight: 700 !important;
}
:deep(.p-datepicker-day.p-datepicker-today > span) {
    background: transparent !important;
    border: 1px solid #f97316 !important;
    color: #f97316 !important;
    font-weight: 700 !important;
}
/* dias de outro mês */
:deep(.p-datepicker-other-month .p-datepicker-day) {
    color: #3f3f3f !important;
}

/* ── KPI Row ─────────────────────────────────────────────────── */
.kpi-row {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.kpi-card-wrap {
    flex: 1;
    min-width: 0;
    cursor: pointer;
}

.kpi-card-wrap:focus-visible {
    outline: 2px solid #f97316;
    outline-offset: 2px;
    border-radius: 8px;
}

/* ── Generic card ────────────────────────────────────────────── */
.dash-card {
    background: #1a1a1a;
    border: 1px solid #2a2a2a;
    border-radius: 8px;
    padding: 14px 16px;
    min-width: 0;
    position: relative;
    overflow: hidden;
    transition: border-color 0.2s;
}
.dash-card:hover {
    border-color: #444444;
}

.chart-loader {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(26, 26, 26, 0.7);
    backdrop-filter: blur(2px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 10;
}
.chart-loader span {
    margin-top: 12px;
    font-size: 0.85rem;
    font-weight: 700;
    color: #f97316;
    letter-spacing: 0.05em;
}

.card-title {
    margin: 0 0 12px;
    font-size: 0.82rem;
    font-weight: 700;
    color: #f97316;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    position: relative;
}

/* ── Top Grid ────────────────────────────────────────────────── */
.top-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

/* ── Middle Grid ─────────────────────────────────────────────── */
.mid-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
}

/* ── Bottom Grid ─────────────────────────────────────────────── */
.bot-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

/* ── Responsive ──────────────────────────────────────────────── */
@media (max-width: 1100px) {
    .mid-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 720px) {
    .top-grid,
    .mid-grid,
    .bot-grid { grid-template-columns: 1fr; }
    .kpi-row  { flex-direction: column; }
}
</style>
